import api from "../../utils/api/api.utils";
export var createGenerator = function (paramsGenerator) {
    var resource = paramsGenerator.resource;
    return function (params) {
        return api.post("/".concat(resource), { data: params.data });
    };
};
